import {z} from 'zod';

import {isNil} from 'ramda';

import {catalogueValidationErrors} from './catalogueUi';

/** The data path of a schema error inside an operation of a batch, as `operations.2.body.version`. */
const OPERATION_FIELD = /^operations\.(\d+)(\.|$)/;

const batchError = z.object({
  data: z.object({
    errors: z
      .array(z.object({operationIndex: z.number().int().nonnegative().optional()}))
      .optional(),
  }),
});

/**
 * The entry whose operation a batch error names: its `operationIndex`, else the operation of a
 * schema error whose `field` starts with `operations.{i}`. An error of the commit (DMS-NV-CT-0012,
 * DMS-NV-CT-0016, DMS-NV-CT-0032) has no `operationIndex` and names no entry.
 */
export const failedEntryIndex = (error: unknown, operationEntries: number[]) => {
  const operationIndex = batchError
    .safeParse(error)
    .data?.data.errors?.find((item) => !isNil(item.operationIndex))?.operationIndex;
  const field = catalogueValidationErrors(error)
    .map((validation) => OPERATION_FIELD.exec(validation.field)?.[1])
    .find((index) => !isNil(index));
  const index = operationIndex ?? (isNil(field) ? undefined : Number(field));
  return isNil(index) ? undefined : operationEntries[index];
};
